import styled from "styled-components";

export default styled.div`


button{
  margin-top: 20px;
  margin-bottom: 20px;
}

main{
  display: flex;
  align-items: flex-start;
  height: auto;
  gap: ${props => props.theme.spacing.spacing_04};
  background-color: transparent;
}

`